import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAccessBadgeCarrier } from '@obvious.tech/constellation'

export const AccessBadgeCarrier = defineEntity('AccessBadgeCarrier', {
  endpoint: 'accesscontrol/api/AccessBadgeCarrier',
  schema: SNoop<IAccessBadgeCarrier>(),
})
